export default "__VITE_ASSET__f24f6805__"